export const siteLanguageRuleOptions = [{
  id: 'ar',
  value: 'Arabic (العربية)'
}, {
  id: 'bg',
  value: 'Bulgarian (Български)'
}, {
  id: 'ca',
  value: 'Catalan (Catalá)'
}, {
  id: 'zh',
  value: 'Chinese - Traditional (繁體中文)'
}, {
  id: 'hr',
  value: 'Croatian (hrvatski)'
}, {
  id: 'cs',
  value: 'Czech (Čeština)'
}, {
  id: 'da',
  value: 'Danish (dansk)'
}, {
  id: 'nl',
  value: 'Dutch (Nederlands)'
}, {
  id: 'en',
  value: 'English'
}, {
  id: 'fr',
  value: 'French (français)'
}, {
  id: 'de',
  value: 'German (Deutsch)'
}, {
  id: 'el',
  value: 'Greek (ελληνικά)'
}, {
  id: 'he',
  value: 'Hebrew (עברית)'
}, {
  id: 'fi',
  value: 'Finnish (Suomi)'
}, {
  id: 'hi',
  value: 'Hindi (हिन्दी)'
}, {
  id: 'hu',
  value: 'Hungarian (Magyar)'
}, {
  id: 'id',
  value: 'Indonesian (Bahasa Indonesia)'
}, {
  id: 'it',
  value: 'Italian (Italiano)'
}, {
  id: 'ja',
  value: 'Japanese (日本語)'
}, {
  id: 'ko',
  value: 'Korean (한국어)'
}, {
  id: 'lv',
  value: 'Latvian (Latviski)'
}, {
  id: 'ms',
  value: 'Malay (Bahasa Melayu)'
}, {
  id: 'no',
  value: 'Norwegian (Norsk)'
}, {
  id: 'pl',
  value: 'Polish (Polski)'
}, {
  id: 'pt',
  value: 'Portuguese (Português)'
}, {
  id: 'ro',
  value: 'Romanian (Română)'
}, {
  id: 'ru',
  value: 'Russian (Русский)'
}, {
  id: 'sk',
  value: 'Slovak (Slovenčina)'
}, {
  id: 'sl',
  value: 'Slovenian (Slovenščina)'
}, {
  id: 'es',
  value: 'Spanish (español)'
}, {
  id: 'sv',
  value: 'Swedish (Svenska)'
}, {
  id: 'tl',
  value: 'Tagalog (Tagalog)'
}, {
  id: 'th',
  value: 'Thai (ภาษาไทย)'
}, {
  id: 'tr',
  value: 'Turkish (Türkçe)'
}, {
  id: 'uk',
  value: 'Ukrainian (Українська)'
}, {
  id: 'lt',
  value: 'Lithuanian (Lietuvių Kalba)'
}, {
  id: 'vi',
  value: 'Vietnamese (Tiếng Việt)'
}];
//# sourceMappingURL=site-language-rule-options.js.map